import { render, staticRenderFns } from "./edit-app.vue?vue&type=template&id=303a67f4&scoped=true&"
import script from "./edit-app.vue?vue&type=script&lang=ts&"
export * from "./edit-app.vue?vue&type=script&lang=ts&"
import style0 from "./edit-app.vue?vue&type=style&index=0&id=303a67f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a67f4",
  null
  
)

export default component.exports